/**
 * Gift card recipient form — enable Shopify email-to-recipient properties.
 * Mirrors Dawn's recipient-form behavior without the custom element / pub-sub stack.
 */
(function () {
  'use strict';

  function initRecipientForm(root) {
    if (!root || root.getAttribute('data-recipient-ready') === 'true') return;
    root.setAttribute('data-recipient-ready', 'true');

    var checkbox = root.querySelector('[data-recipient-checkbox]');
    var control = root.querySelector('[data-recipient-control]');
    var offset = root.querySelector('[data-recipient-offset]');
    var fieldsWrap = root.querySelector('[data-recipient-fields]');
    var fields = root.querySelectorAll('[data-recipient-field]');
    var liveRegion = root.querySelector('[data-recipient-live-region]');
    var emailField = root.querySelector('input[type="email"][data-recipient-field]');

    if (!checkbox || !control) return;

    // JS-capable: checkbox is the control; disable the no-JS sentinel.
    checkbox.disabled = false;
    control.disabled = true;

    if (offset) {
      offset.value = String(new Date().getTimezoneOffset());
    }

    function setFieldsEnabled(enabled) {
      Array.prototype.forEach.call(fields, function (field) {
        field.disabled = !enabled;
        if (!enabled) {
          if (field.type === 'checkbox') {
            field.checked = false;
          } else {
            field.value = '';
          }
        }
      });
      if (offset) offset.disabled = !enabled;
      if (fieldsWrap) {
        if (enabled) {
          fieldsWrap.removeAttribute('hidden');
        } else {
          fieldsWrap.setAttribute('hidden', 'hidden');
        }
      }
      if (emailField) {
        if (enabled) {
          emailField.setAttribute('required', 'required');
        } else {
          emailField.removeAttribute('required');
        }
      }
      if (liveRegion) {
        liveRegion.textContent = enabled
          ? 'Recipient email fields expanded'
          : 'Recipient email fields collapsed';
      }
    }

    function sync() {
      setFieldsEnabled(checkbox.checked);
    }

    checkbox.addEventListener('change', sync);
    sync();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-gift-card-recipient]');
    Array.prototype.forEach.call(roots, initRecipientForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
